/* ═══════════════════════════════════════════════════════
   EUROBASED HOMEPAGE JAVASCRIPT
   Version: 1.1
   ═══════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ═══════════════════════════════════════
     UTILITIES
     ═══════════════════════════════════════ */

  function throttle(func, delay) {
    let lastCall = 0;
    return function(...args) {
      const now = Date.now();
      if (now - lastCall >= delay) {
        lastCall = now;
        func.apply(this, args);
      }
    };
  }

  function initHeroHeadlineAnimation() {
    const headline = document.querySelector('[data-hero-headline]');
    if (!headline) return;

    const words = headline.querySelectorAll('.eb-hero__headline-word');
    if (words.length === 0) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      words.forEach(word => {
        word.style.opacity = '1';
        word.style.transform = 'none';
      });
      return;
    }

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      words.forEach(word => {
        word.style.opacity = '1';
        word.style.transform = 'none';
      });
      return;
    }

    words.forEach((word, index) => {
      const delay = parseInt(word.dataset.stagger) || index * 300;
      setTimeout(() => {
        word.style.animation = 'eb-hero-word-appear 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards';
      }, delay);
    });
  }

  function initHeroScrollIndicator() {
    const indicator = document.querySelector('.eb-hero__scroll-indicator');
    if (!indicator) return;

    indicator.style.cursor = 'pointer';

    indicator.addEventListener('click', (e) => {
      e.preventDefault();

      const heroElement = document.querySelector('.eb-hero');
      if (!heroElement) return;

      const heroSection = heroElement.closest('.shopify-section');
      if (!heroSection) return;

      const nextSection = heroSection.nextElementSibling;
      if (!nextSection) return;

      nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initHomepage() {
    initHeroHeadlineAnimation();
    initHeroScrollIndicator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomepage);
  } else {
    initHomepage();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.classList.contains('section-homepage-hero')) {
      setTimeout(initHomepage, 100);
    }
  });
})();

/* ============================================
   PROBLEM SECTION
   ============================================ */

(function() {
  'use strict';
  
  function initProblemCounters() {
    const counters = document.querySelectorAll('.eb-problem__stat-number[data-counter-target]');
    if (!counters.length) return;
    
    let hasAnimated = false;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobileOrTablet = window.innerWidth <= 1024; // Mobile & Tablet: keine Animation
    
    function easeOutQuart(t) {
      return 1 - Math.pow(1 - t, 4);
    }
    
    function animateCounter(element) {
      const target = parseInt(element.getAttribute('data-counter-target'), 10);
      const suffix = element.getAttribute('data-counter-suffix') || '';
      const duration = (prefersReducedMotion || isMobileOrTablet) ? 0 : 1500; // Keine Animation auf Mobile/Tablet
      
      if (duration === 0) {
        element.textContent = target.toLocaleString('de-DE') + suffix;
        return;
      }
      
      const startTime = performance.now();
      let lastValue = -1;
      let frameCount = 0;
      
      function update(currentTime) {
        frameCount++;
        // Nur jeden 2. Frame updaten für bessere Performance auf Mobile
        if (frameCount % 2 !== 0 && frameCount > 1) {
          requestAnimationFrame(update);
          return;
        }
        
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easeOutQuart(progress);
        const currentValue = Math.floor(easedProgress * target);
        
        // Nur updaten wenn sich der Wert geändert hat (vermeidet Layout-Thrashing)
        if (currentValue !== lastValue) {
          element.textContent = currentValue.toLocaleString('de-DE') + suffix;
          lastValue = currentValue;
        }
        
        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          element.textContent = target.toLocaleString('de-DE') + suffix;
        }
      }
      
      requestAnimationFrame(update);
    }
    
    counters.forEach(counter => {
      const statCard = counter.closest('.eb-problem__stat');
      if (statCard) statCard.classList.add('is-visible');
    });
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasAnimated) {
          hasAnimated = true;
          counters.forEach((counter, index) => {
            setTimeout(() => animateCounter(counter), index * 150);
          });
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });
    
    const section = document.querySelector('.eb-problem');
    if (section) observer.observe(section);
  }
  
  function initProblemModal() {
    const modal = document.getElementById('modal-berlin-blackout');
    const triggers = document.querySelectorAll('[data-modal-trigger="berlin-blackout"]');
    
    if (!modal || !triggers.length) return;
    
    let focusedElementBeforeModal = null;
    let savedScrollY = 0;
    const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function openModal() {
      focusedElementBeforeModal = document.activeElement;
      savedScrollY = window.scrollY;
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';

      setTimeout(() => {
        const firstFocusable = modal.querySelector(focusableSelector);
        if (firstFocusable) firstFocusable.focus();
      }, 100);

      document.addEventListener('keydown', handleKeydown);
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, savedScrollY);
      if (focusedElementBeforeModal) focusedElementBeforeModal.focus();
      document.removeEventListener('keydown', handleKeydown);
    }
    
    function handleKeydown(e) {
      if (e.key === 'Escape') {
        closeModal();
        return;
      }
      
      if (e.key === 'Tab') {
        const focusables = modal.querySelectorAll(focusableSelector);
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        
        if (e.shiftKey && document.activeElement === first) {
          last.focus();
          e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    }
    
    triggers.forEach(trigger => {
      trigger.addEventListener('click', openModal);
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal();
        }
      });
    });
    
    modal.querySelectorAll('[data-modal-close]').forEach(btn => btn.addEventListener('click', closeModal));
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
  }
  
  function init() {
    initProblemCounters();
    initProblemModal();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target.querySelector('.eb-problem')) init();
    });
  }
})();

/* ============================================
   WHY & STEPS SECTIONS
   ============================================ */

(function() {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initStepsSection() {
    const stepsSection = document.querySelector('.eb-steps');
    if (!stepsSection) return;

    const circles = stepsSection.querySelectorAll('.eb-steps__circle');
    const cards = stepsSection.querySelectorAll('.eb-steps__card');
    
    if (circles.length === 0) return;

    if (!prefersReducedMotion) {
      circles.forEach(circle => {
        circle.style.opacity = '0';
        circle.style.transform = 'scale(0.8)';
      });
      cards.forEach(card => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(20px)';
      });
    }

    function animateNumber(element, target) {
      const duration = 800;
      const startTime = performance.now();

      function update(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 2);
        const current = Math.floor(target * easeProgress);
        element.textContent = current;
        if (progress < 1) requestAnimationFrame(update);
        else element.textContent = target;
      }

      requestAnimationFrame(update);
    }

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const section = entry.target;
          const circles = section.querySelectorAll('.eb-steps__circle');
          const numbers = section.querySelectorAll('.eb-steps__circle-number');
          const cards = section.querySelectorAll('.eb-steps__card');

          circles.forEach((circle, index) => {
            setTimeout(() => {
              if (!prefersReducedMotion) {
                circle.style.transition = 'opacity 0.5s ease-out, transform 0.5s ease-out';
                circle.style.opacity = '1';
                circle.style.transform = 'scale(1)';
              }
              const numberEl = numbers[index];
              if (numberEl) {
                const targetNumber = parseInt(numberEl.getAttribute('data-number'));
                if (!isNaN(targetNumber) && !prefersReducedMotion) animateNumber(numberEl, targetNumber);
              }
            }, index * 300);
          });

          cards.forEach((card, index) => {
            setTimeout(() => {
              if (!prefersReducedMotion) {
                card.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }
            }, (circles.length * 300) + (index * 100));
          });

          observer.unobserve(section);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, { threshold: 0.2, rootMargin: '0px 0px -50px 0px' });
    observer.observe(stepsSection);
  }

  function initHoverEffects() {
    const circles = document.querySelectorAll('.eb-steps__circle');
    circles.forEach(circle => {
      circle.addEventListener('click', function(e) {
        e.preventDefault();
        this.style.transform = 'scale(1.1)';
        setTimeout(() => { this.style.transform = 'scale(1)'; }, 200);
      });
    });
  }

  function handleThemeEditorEvents() {
    if (typeof Shopify === 'undefined' || !Shopify.designMode) return;
    document.addEventListener('shopify:section:load', function(event) {
      const sectionId = event.detail.sectionId;
      const section = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!section) return;
      if (section.classList.contains('eb-steps')) initStepsSection();
    });
  }

  function runInit() {
    initStepsSection();
    initHoverEffects();
    handleThemeEditorEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }
})();

/* ============================================
   STEPS SECTION - Connector Lines + Particles
   ============================================ */

function initStepsConnectors() {
  const circles = document.querySelectorAll('.eb-steps__circle');
  const connectors = document.querySelectorAll('.eb-steps__connector');
  
  if (circles.length < 2 || connectors.length < 1) return;
  
  connectors.forEach(function(svg, i) {
    const thisCircle = circles[i];
    const nextCircle = circles[i + 1];
    
    if (!thisCircle || !nextCircle) return;
    
    const thisRect = thisCircle.getBoundingClientRect();
    const nextRect = nextCircle.getBoundingClientRect();
    const lineWidth = nextRect.left - thisRect.right;
    
    if (lineWidth <= 0) return;
    
    svg.style.position = 'absolute';
    svg.style.left = '50%';
    svg.style.marginLeft = (thisRect.width / 2) + 'px';
    svg.style.top = (thisRect.height / 2) + 'px';
    svg.style.width = lineWidth + 'px';
    svg.style.height = '20px';
    svg.style.transform = 'translateY(-50%)';
    svg.style.overflow = 'visible';
    svg.setAttribute('viewBox', '0 0 ' + lineWidth + ' 20');
    
    const line = svg.querySelector('.eb-steps__connector-line');
    if (line) {
      line.setAttribute('x1', '0');
      line.setAttribute('y1', '10');
      line.setAttribute('x2', lineWidth);
      line.setAttribute('y2', '10');
      line.removeAttribute('stroke-dasharray');
      line.removeAttribute('stroke-dashoffset');
    }
    
    svg.querySelectorAll('.eb-steps__flow-particle').forEach(function(particle, pi) {
      const oldAnim = particle.querySelector('animate');
      if (oldAnim) oldAnim.remove();
      
      const anim = document.createElementNS('http://www.w3.org/2000/svg', 'animate');
      anim.setAttribute('attributeName', 'cx');
      anim.setAttribute('from', '0');
      anim.setAttribute('to', lineWidth);
      anim.setAttribute('dur', '4s');
      anim.setAttribute('begin', (pi * 2) + 's');
      anim.setAttribute('repeatCount', 'indefinite');
      
      particle.appendChild(anim);
      particle.setAttribute('r', '4');
      particle.setAttribute('cy', '10');
      particle.style.opacity = '0.9';
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { setTimeout(initStepsConnectors, 100); });
} else {
  setTimeout(initStepsConnectors, 100);
}

// Throttle resize handler to avoid excessive recalculations
const handleStepsResize = throttle(initStepsConnectors, 150);
window.addEventListener('resize', handleStepsResize);

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.eb-steps')) setTimeout(initStepsConnectors, 150);
  });
}

if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.eb-steps__flow-particle animate').forEach(function(a) { a.remove(); });
  });
}
